module.exports = __webpack_public_path__ + "static/media/icon-libra.dbf5bb61.svg";